<kendo-grid
    kendoGridSelectBy="eventId"
    [data]="events"
    [selectable]="{ mode: 'single' }"
    [pageable]="false"
    [loading]="refreshing"
    [groupable]="false"
    [reorderable]="true"
    [resizable]="true"
    [columnMenu]="{ filter: false }"
    style="height: 100%">
    <ng-template kendoGridToolbarTemplate>
        <kendo-buttongroup>
            <button
                kendoButton
                type="button"
                themeColor="info"
                [disabled]="!events || events.length === 0"
                title="{{ 'labels.refresh' | translate }}"
                (click)="refreshFiles()">
                <kendo-svg-icon [icon]="arrowRotateCwIcon"></kendo-svg-icon>
                {{ 'labels.refresh' | translate }}
            </button>
        </kendo-buttongroup>
    </ng-template>
    <kendo-grid-column
        [width]="50"
        headerClass="k-text-center"
        class="k-text-center"
        title="{{ 'grid.columns.actions' | translate }}"
        [filterable]="false"
        [groupable]="false"
        [includeInChooser]="false"
        [sortable]="false"
        [resizable]="true"
        [editable]="false"
        [reorderable]="false">
        <ng-template kendoGridCellTemplate let-dataItem>
            <kendo-buttongroup>
                <button
                    *ngIf="dataItem.eventTxId"
                    kendoButton
                    [clflCopyClipboard]="dataItem.eventTxId"
                    type="button"
                    fillMode="outline"
                    themeColor="info"
                    title="{{ 'labels.copyToClipboard' | translate }}"
                    (copied)="copyToClipboard($event)">
                    <kendo-svg-icon [icon]="saveIcon"></kendo-svg-icon>
                </button>
                <button
                    *ngIf="dataItem.longitude && dataItem.latitude"
                    kendoButton
                    type="button"
                    fillMode="outline"
                    themeColor="error"
                    title="{{ 'labels.map' | translate }}"
                    (click)="openGoogleMaps(dataItem)">
                    <kendo-svg-icon [icon]="globeIcon"></kendo-svg-icon>
                </button>
            </kendo-buttongroup>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="title"
        [width]="75"
        headerClass="k-text-center"
        class="k-text-left"
        title="{{ 'cf-document.tab.events.column.title' | translate }}">
    </kendo-grid-column>
    <kendo-grid-column
        field="blockchainStatus"
        [width]="50"
        headerClass="k-text-center"
        class="k-text-center"
        title="{{ 'cf-document.tab.events.column.blockchainStatus' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span class="badge {{ getStatusColor(dataItem.jobStatus) }}">
                {{ dataItem.jobStatus }}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="eventType"
        [width]="50"
        headerClass="k-text-center"
        class="k-text-center"
        title="{{ 'cf-document.tab.events.column.type' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span class="badge badge-info">
                {{ dataItem.eventType }}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="hasAttachment"
        title="{{ 'cf-document.tab.events.column.hasAttachment' | translate }}"
        [width]="50"
        headerClass="k-text-center"
        class="k-text-center">
        <ng-template kendoGridCellTemplate let-dataItem>
            {{ (dataItem.hasAttachment ? 'labels.yes' : 'labels.no') | translate }}
        </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
        field="documentHash"
        [width]="50"
        headerClass="k-text-center"
        class="k-text-left"
        title="{{ 'cf-document.tab.events.column.documentHash' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <div class="doc-hash" title="{{ dataItem.documentHash }}">
                {{ dataItem.documentHash }}
            </div>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="createdAt"
        [width]="75"
        headerClass="k-text-center"
        class="k-text-right"
        title="{{ 'grid.columns.createdAt' | translate }}">
        <ng-template kendoGridCellTemplate let-dataItem>
            <span>
                {{ dataItem.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}
            </span>
        </ng-template>
    </kendo-grid-column>
    <kendo-grid-column
        field="createdBy"
        [width]="75"
        headerClass="k-text-center"
        class="k-text-left"
        title="{{ 'grid.columns.createdBy' | translate }}">
    </kendo-grid-column>

    <ng-template kendoGridDetailTemplate let-dataItem>
        <kendo-card>
            <kendo-card-header> </kendo-card-header>
            <kendo-card-body>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.title' | translate }}:</strong> {{ dataItem.title }}
                </p>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.type' | translate }}:</strong> {{ dataItem.eventType }}
                </p>
                <p>
                    <strong>{{ 'grid.columns.createdAt' | translate }}:</strong> {{ dataItem.createdAt | date: 'dd-MM-yyyy HH:mm:ss' }}
                </p>
                <p>
                    <strong>{{ 'grid.columns.createdBy' | translate }}:</strong> {{ dataItem.createdBy }}
                </p>
                <p *ngIf="dataItem.longitude && dataItem.latitude">
                    <strong>Locatie:</strong>
                    <button
                        kendoButton
                        type="button"
                        fillMode="outline"
                        themeColor="error"
                        title="{{ 'labels.map' | translate }}"
                        (click)="openGoogleMaps(dataItem)">
                        <kendo-svg-icon [icon]="globeIcon"></kendo-svg-icon>
                    </button>
                </p>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.mention' | translate }}:</strong> {{ dataItem.mention }}
                </p>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.hasAttachment' | translate }}:</strong>
                    {{ (dataItem.hasAttachment ? 'labels.yes' : 'labels.no') | translate }}
                    <kendo-buttongroup *ngIf="dataItem.hasAttachment">
                        <button
                            kendoButton
                            type="button"
                            fillMode="outline"
                            themeColor="info"
                            title="{{ 'labels.download' | translate }}"
                            (click)="downloadFile(dataItem.attachment)">
                            <kendo-svg-icon [icon]="downloadIcon"></kendo-svg-icon>
                        </button>
                    </kendo-buttongroup>
                </p>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.section' | translate }}:</strong> {{ dataItem.sectionName }}
                </p>
                <p>
                    <strong>{{ 'cf-document.tab.events.column.documentHash' | translate }}:</strong> {{ dataItem.documentHash }}
                </p>
                <p>
                    <strong>{{ 'labels.copyToClipboard' | translate }}:</strong>
                    <button
                        *ngIf="dataItem.eventTxId"
                        kendoButton
                        [clflCopyClipboard]="dataItem.eventTxId"
                        type="button"
                        fillMode="outline"
                        themeColor="info"
                        title="{{ 'labels.copyToClipboard' | translate }}"
                        (copied)="copyToClipboard($event)">
                        <kendo-svg-icon [icon]="saveIcon"></kendo-svg-icon>
                    </button>
                </p>
            </kendo-card-body>
        </kendo-card>
    </ng-template>
</kendo-grid>
